<svelte:options accessors/>
<script lang="ts">
    import PagosDisponibles from "./PagosDisponibles.svelte";
    import {getFormatter} from "../../utils";
    import PagosFormasDisponibles from "./PagosFormasDisponibles.svelte";
    import type {ITableField} from "../../interfaces";

    const formatter = getFormatter();
    export let resumen = [
        {titulo: 'Tipo de póliza', atributo: 'descripcion'},
        {titulo: 'No. Póliza',atributo: 'numero_poliza'},
        {titulo: 'Endoso', atributo: 'endoso'},
        {titulo: 'Cuota', atributo: 'numero'}]

    export let data: {
        infoPoliza: IInformacionPoliza,
        detallesPago: IDetallesPago,
        cuotas: Array<{
            slug: string;
            numero: number;
            fechaLimitePago: string;
            valor: number;
            estado: {
                code: number;
                label: string;
            };
            recibo: Array<{
                icon: string;
                route: string;
            }>;
        }>
    } = {};

    let hideSearch = true;
    let formasPago = false;

    interface IInformacionPoliza {
        tomador: string;
        producto: string;
        poliza: string;
        endoso: number;
        riesgo: string;
        vigencia: string;
    }

    interface IDetallesPago {
        valorPendiente: number;
        fechaLimitePago: string;
        formaPago: string;
        cuotasPendientes: number;
    }

    let columns: Array<ITableField> = [
        {
            slug: "check",
            label: "",
            type: "checkbox",
            order: false
        },
        {
            slug: "numero",
            label: "No. cuota",
            type: "text",
            order: true
        },
        {
            slug: "fechaLimitePago",
            label: "Fecha límite de pago",
            type: "date",
            order: true,
            customClass: (slug: any) => {
                const item = data.cuotas.find(d => d.slug === slug)
                if (+item.estado.code === 3) {
                    return 'fecha-vence';
                }
                return '';
            }
        },
        {
            slug: "valor",
            label: "Valor",
            align: "center",
            type: "currency",
            bold: true,
            order: true
        },
        {
            slug: "estado",
            label: "Estado pago",
            type: "state",
            order: true
        },
        {
            slug: "recibo",
            width: "250px",
            align: "center",
            label: "El recibo de pago en banco",
            type: "actions",
            order: true
        }
    ]

    export let url_pagos;

</script>
<div>
    <fieldset>
        <legend>Información de la póliza</legend>
        <table class="simple-table">
            <tr>
                <td style="min-width: 200px;">Tomador</td>
                <td>{data.infoPoliza.tomador}</td>
            </tr>
            <tr>
                <td style="min-width: 200px;">Producto</td>
                <td>{data.infoPoliza.producto}</td>
            </tr>
            <tr>
                <td style="min-width: 200px;">No. Póliza</td>
                <td>{data.infoPoliza.poliza}</td>
            </tr>
            <tr>
                <td style="min-width: 200px;">Endoso</td>
                <td>{data.infoPoliza.endoso}</td>
            </tr>
            <tr>
                <td style="min-width: 200px;">Riesgo</td>
                <td>{data.infoPoliza.riesgo}</td>
            </tr>
            <tr>
                <td style="min-width: 200px;">Vigencia</td>
                <td>{data.infoPoliza.vigencia}</td>
            </tr>
        </table>
    </fieldset>
    <fieldset>
        <legend>Detalles del pago</legend>
        <div class="grid-2 gap-3 items-start">
            <table class="simple-table w-max-content">
                <tr>
                    <td style="min-width: 200px;">Valor pendiente</td>
                    <td><strong>{formatter(data.detallesPago.valorPendiente)}</strong></td>
                </tr>
                <tr>
                    <td style="min-width: 200px;">Fecha límite de pago</td>
                    <td>{data.detallesPago.fechaLimitePago}</td>
                </tr>
                <tr>
                    <td style="min-width: 200px;">Forma de pago</td>
                    <td>{data.detallesPago.formaPago}</td>
                </tr>
                <tr>
                    <td style="min-width: 200px;">No. cuotas pendientes</td>
                    <td>{data.cuotas.length}</td>
                </tr>
            </table>
            <div class="box-r">
                <div class="back-gray p-1 radius" style="max-width: 450px;">
                    <strong>Formas de pago:</strong> Conozca las <span class="pointer secondary"
                                                                       on:click={()=> formasPago = true}>formas de pago</span>
                    que se encuentran disponibles desde esta
                    plataforma.
                </div>
            </div>
        </div>
    </fieldset>
    <PagosDisponibles data="{data.cuotas}" {url_pagos} detalles={true} {resumen} {columns} {hideSearch}/>
    <PagosFormasDisponibles bind:open={formasPago}/>
</div>